<template lang="pug">
    .register-wrapper(v-if="shown")
        h3 Your details
        .form-group(
            :class="{ 'has-error': compErrors['firstname']}"
        )
            label(for="firstnameInput") Firstname
            input(
                v-model="firstname"
                class="form-control"
                id="firstnameInput"
            )

        .form-group(
            :class="{ 'has-error': compErrors['surname']}"
        )
            label(for="surnameInput") Surname
            input(
                v-model="surname"
                class="form-control"
                id="surnameInput"
            )

        .form-group(
            :class="{ 'has-error': compErrors['email']}"
        )
            label(for="emailInput") Email
            input(
                v-model="email"
                type="text"
                class="form-control"
                id="emailInput"
                name="email"
            )
            p(v-if="showRestrictedEmailEntry") Only register with your ox.ac.uk email

        .form-group
            label(for="postcodeInput") Postcode
            input(
                v-model="postcode"
                class="form-control"
                id="postcodeInput"
            )
        
        .form-group(
            v-show="showRestrictedEmailEntry"
            :class="{ 'has-error': compErrors['highestQualification']}"
        )
            label(for="qualificationDrpdwn") Highest qualification
            select(
                class="form-control",
                id="qualificationDrpdwn",
                v-on:change="handleHightesQualificationChange"
                v-model="highestQualification"
            )
                option(v-for="k in this.qualificationsList", :value="`${k.key}`") {{ k.description }}

        .form-group(
            v-show="showRestrictedEmailEntry"
            :class="{ 'has-error': compErrors['divisionalInformation']}"
        )
            label(for="divisionalInformationDropDown") Divisional Information
            select(
                class="form-control",
                id="divisionalInformationDropDown",
                v-on:change="handleDivisionalInformationChange"
                v-model="divisionalInformation"
            )
                option(v-for="k in this.dataDivList", :value="`${k.id}`") {{ k.name +' - '+k.shortCode }}

        .form-group(
            v-show="showRestrictedEmailEntry"
            :class="{ 'has-error': compErrors['currentStudyProgramme']}"
        )
            label(for="currentStudyProgramme") Current Study Programme
            input(
                v-model="currentStudyProgramme"
                class="form-control"
                id="currentStudyProgramme"
            )

        .form-group
            input(
                type="checkbox"    
                id="emailOptinInput"
                v-model="emailOptin"
            )
            label(for="emailOptinInput") Yes - please keep me informed by email about Oxford Continuing Education courses, open days, research and student information

        .form-group
            input(
                type="checkbox"    
                id="overEighteenInput"
                v-model="overEighteenOptin"
                v-on:click="handleOverEighteenRadioClick"
            )
            label(for="overEighteenInput") I am at least 18 years old
            
</template>


<script>
import validator from 'validator'
import _ from 'lodash'

export default {
    name: 'register',
    data() {
        return {
            firstname: "",
            surname: "",
            email: "",
            postcode: "",
            dataProtection: false,
            emailOptin: false,
            overEighteenOptin: false,
            highestQualification: "",
            divisionalInformation: "",
            currentStudyProgramme: "",
            dataDivList:  [
                {
                    id: 2,
                    name: "Mathematical, Physical, Engineering and Life Sciences",
                    shortCode: "MPLS",
                },
                {
                    id: 3,
                    name: "Medical Sciences Division",
                    shortCode: "MSD",
                },
                {
                    id: 4,
                    name: "Humanities",
                    shortCode: "Hum",
                },
                {
                    id: 5,
                    name: "Social Sciences",
                    shortCode: "SSD",
                },
                {
                    id: 6,
                    name: "Continuing Education",
                    shortCode: "OUDCE",
                },
                {
                    id: 7,
                    name: "Gardens, Libraries and Museums",
                    shortCode: "GLAM",
                }
            ] ,
            errors: {
                firstname: false,
                surname: false,
                email: false,
                postcode: false,
                highestQualification: false,
                divisionalInformation: false,
                currentStudyProgramme: false
            }
        }
    },
    props: ['shown', 'showRestrictedEmailEntry', 'qualificationsList'],
    methods: {
        handleHideClick() {
            this.$emit("hide")
            console.dir(this.$validator.errorBag) // test
        },
        handleHighestQualificationError() {
            if (this.showRestrictedEmailEntry) {
                // Hackish way as error not detected unless select is changed
                this.errors['highestQualification'] = this.highestQualification === "";
            }
        },
          handleDivisionalInformationError() {
            if (this.showRestrictedEmailEntry) {
                // Hackish way as error not detected unless select is changed
                this.errors['divisionalInformation'] = this.divisionalInformations === "";
            }
        },
    
        handleOverEighteenRadioClick() {
          this.$emit('handleOverEighteenRadioClick', this.overEighteenOptin)
          this.handleHighestQualificationError()
        },
        handleHightesQualificationChange(event) {
          this.errors['highestQualification'] = this.highestQualification === "";
          this.handleHighestQualificationError()
        },
        handleDivisionalInformationChange(event) {  
            this.errors['divisionalInformation'] = this.divisionalInformation === "";
            this.$store.dispatch('setDivisionalInformation', this.divisionalInformation);          
        },

    },

    watch: {
        firstname() {
            this.errors['firstname'] = this.firstname === "";
            this.$emit('firstname', this.firstname);
        },
        surname() {
            this.$emit('surname', this.surname);
        },
        email() {
            let valid = !validator.isEmail(this.email)
            this.errors['email'] = valid
            this.$emit('email', this.email);
        },
        postcode() {
            this.$emit('postcode', this.postcode);
        },
        dataProtection() {
            this.$emit('dataProtection', this.dataProtection);
        },
        emailOptin() {
            this.$emit('emailOptin', this.emailOptin);
        },
        overEighteenOptin() {
            this.$emit('overEighteenOptin', this.overEighteenOptin);
        },
        hasErrors() {
            this.$emit('registerError', this.hasErrors)
        },
        divisionalInformation() {
            this.$emit('divisionalInformation', this.divisionalInformation)
        },
        highestQualification() {
            this.$emit('highestQualification', this.highestQualification)
        },
        currentStudyProgramme() {
            console.log('emitting current study program' + this.currentStudyProgramme)
            this.$emit('currentStudyProgramme', this.currentStudyProgramme)
        }

    },

    computed: {
        compErrors() {
            return this.errors;
        },
        
        hasErrors() {
            let hasErrors = _(this.errors)
              .mapValues(x => !!x)
              .values()
              .some()


            return hasErrors
        }
    }
}
</script>


<style lang="stylus" scoped>
    .hide-wrapper
        text-align: center
        font-size: 1.5em

    .hide-text
        cursor: pointer

    .hide-wrapper > hr
        margin: 0
        border-color: grey

    #emailOptinInput + label
      display: inline
      margin-left: 5px

    #overEighteenInput + label
      display: inline
      margin-left: 5px
</style>



// WEBPACK FOOTER //
// src/components/Register.vue